import { DexDispatcherFormEnumType } from '@mark43/cad-api';
import { QueryableEntityType } from 'federated-search/*';
import { getDataExchangeFormPanelMatcher } from '../../common/helpers/get-data-exchange-form-panel-matcher';
import { useEnabledFeatures } from '../../common/hooks/enabled-features';
import { handleExistingDexFormPanel } from '../helpers/handle-existing-dex-form-panel';
import { useWorkspaceStore } from '../use-workspace-store';
import { useOpenWorkspacePanel } from '../use-open-workspace-panel';
import { useDexNextForms } from './use-dex-next-forms';
import {
    EventWorkspacePanelDexFormPrefill,
    EventWorkspacePanelDexNextFormPrefill,
    PanelStateForWorkspacePanelType,
} from '../workspace-panel-types';

export function useHandleOpenInDexButtonClick({
    dexFormQuery,
    dexNextEntityType,
    getDexFormValues,
    getDexNextFormValues,
}: {
    dexFormQuery: DexDispatcherFormEnumType;
    dexNextEntityType?: QueryableEntityType;
    getDexFormValues: () => EventWorkspacePanelDexFormPrefill;
    getDexNextFormValues: () => EventWorkspacePanelDexNextFormPrefill;
}) {
    const workspacePanelsStore = useWorkspaceStore();
    const openWorkspacePanel = useOpenWorkspacePanel();
    const { dexNextEnabled } = useEnabledFeatures();
    const { getFormByEntityType } = useDexNextForms();

    const {
        id: dexNextFormId = undefined,
        displayName: dexNextFormName = undefined,
    } = dexNextEntityType ? getFormByEntityType(dexNextEntityType) || {} : {};

    return () => {
        const existingPanel = workspacePanelsStore
            .getActivePanels()
            .find((panel) => panel.workspacePanelType === 'DATA_EXCHANGE_FORM');
        const panelState: PanelStateForWorkspacePanelType<'DATA_EXCHANGE_FORM'> = dexNextEnabled
            ? { dexNextFormPrefill: getDexNextFormValues() }
            : { dexFormPrefill: getDexFormValues() };

        if (existingPanel) {
            handleExistingDexFormPanel({
                dexFormQuery,
                existingPanel,
                workspacePanelsStore,
                panelState,
            });

            return;
        }

        openWorkspacePanel({
            matchExistingPanel: getDataExchangeFormPanelMatcher({
                dexForm: dexFormQuery,
                dexNextEnabled,
            }),
            workspacePanelConfig: {
                workspacePanelType: 'DATA_EXCHANGE_FORM',
                dexForm: dexFormQuery,
                dexNextFormId,
                dexNextFormName,
                panelState,
            },
        });
    };
}
